var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.directoryContent && !_vm.errorMessage)?_c('b-table',{attrs:{"thead-class":"hidden_header","striped":"","hover":"","fields":_vm.fields,"items":_vm.directoryContent}}):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',[(_vm.path)?_c('b',[_vm._v(_vm._s(_vm.path))]):_vm._e(),_vm._v(" "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }